import { ReactNode } from "react";

export type Column<T> = { key: string; label: string; render: (row: T) => ReactNode; className?: string };

export function DataTable<T extends { id: string }>({ rows, columns, testId, empty = "No records" }: { rows: T[]; columns: Column<T>[]; testId: string; empty?: string }) {
  return (
    <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white" data-testid={testId}>
      <table className="w-full min-w-[640px] text-left text-sm">
        <thead className="border-b border-slate-200 bg-slate-50">
          <tr>{columns.map((c) => <th key={c.key} className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500">{c.label}</th>)}</tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td className="px-4 py-6 text-center text-slate-500" colSpan={columns.length}>{empty}</td></tr>}
          {rows.map((r) => (
            <tr key={r.id} className="border-b border-slate-100 last:border-0" data-testid={`${testId}-row`}>
              {columns.map((c) => <td key={c.key} className={`px-4 py-3 align-top ${c.className || ""}`}>{c.render(r)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
